import { CheckmarkCircleOutline } from '@randstad-lean-mobile-factory/react-components-ui-shared';
import classnames from 'classnames';

import { Base } from '../Base';
import { Props } from '../Base/Base.types';

import styles from './Success.module.scss';

export const Success = ({ children, className }: Props) => (
  <Base
    icon={<CheckmarkCircleOutline className={styles.icon} />}
    className={classnames(styles.info, className)}
  >
    {children}
  </Base>
);
